import { apiGet, apiPatch, type ApiResponse } from "./genesisApi/httpsMethods";
import { getPipelineClientId } from "@/pages/pipeline/pipelineCellSave";
import type { KillReason } from "../types/deal";
import type {
  MyDataCompleteness,
  UserDataCompleteness,
} from "../types/dataCompleteness";

export async function getMyDataCompleteness(): Promise<
  ApiResponse<MyDataCompleteness>
> {
  return apiGet<MyDataCompleteness>("data-completeness/me");
}

export async function getUsersDataCompleteness(): Promise<
  ApiResponse<UserDataCompleteness[]>
> {
  return apiGet<UserDataCompleteness[]>("data-completeness/users");
}

/** Sets the kill reason on a killed deal that has none. */
export async function saveKillReason(
  dealId: number,
  reason: KillReason,
): Promise<ApiResponse> {
  return apiPatch(`deal/${dealId}`, {
    changes: { kill_reason: reason },
    expected: { kill_reason: null },
    client_id: getPipelineClientId(),
  });
}
